/**
 * 汎用ユーティリティ
 */

export const $ = (selector) => document.querySelector(selector);
export const $$ = (selector) => Array.from(document.querySelectorAll(selector));

/**
 * 指定要素がビューポート内に入ったかどうか
 * @param {Element} el
 * @param {number} [margin=0] マージン（px）
 * @returns {boolean}
 */
export function isInViewport(el, margin = 0) {
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  return (
    rect.top <= window.innerHeight + margin &&
    rect.bottom >= -margin &&
    rect.left <= window.innerWidth + margin &&
    rect.right >= -margin
  );
}
